import {
    LOAD_DATA_CAMP_ALL,
    SET_SELECT_CAMP,
    SET_SELECT_CAMP_ID,
    LOAD_DATA_CAMP_LOGO_MAP
} from './../../actions/camp/index';

const initialState = {
    result: null,
    selectCamp: null,
    selectCampId: null,
    resultMapLogo: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_DATA_CAMP_ALL:
            return { ...state, result: action.payload.items };
        case SET_SELECT_CAMP:
            return { ...state, selectCamp: action.payload.items };
        case SET_SELECT_CAMP_ID:
            return { ...state, selectCampId: action.payload.items };
        case LOAD_DATA_CAMP_LOGO_MAP:
            return { ...state, resultMapLogo: action.payload.items };
        default:
            return state;
    }
}